import { createStyles, makeStyles, Theme } from '@material-ui/core';
import React from 'react';
import { INBOX_PAGE_EMPTY_STATE_LEARN_MORE } from '../../constants/modulesEmptyStates';
import { useGetInboxNotificationsQuery } from '../../services/api/inboxApi';
import { getUnreadInboxNotificationCount } from '../../utils/NotificationsUtils';
import { NotificationIcon } from '../Icons';
import StandardPage from '../UI/StandardPage';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      justifyContent: 'space-between',
      padding: theme.spacing(0, 2),
      width: '100%',
    },
  }),
);

export const InboxEmptyState = () => {
  const classes = useStyles();
  const { data: allInboxNotifications } = useGetInboxNotificationsQuery();

  const unreadNotificationCount = getUnreadInboxNotificationCount(
    allInboxNotifications,
  );

  /**
   * generate description of the empty
   * state i.e. when no notification is selected
   */
  const getEmptyStateDescription = () => {
    // there are no notifications
    if (!allInboxNotifications?.length) {
      return 'When your clients upload files or sign documents, those notifications will be surfaced on this page.';
    }

    // there are no unread notifications
    if (unreadNotificationCount === 0) {
      return 'No unread notifications';
    }
    return `${unreadNotificationCount} unread notification${
      unreadNotificationCount > 1 ? 's' : '' // 'notification` for count:1, 'notifications' for count > 1
    }`;
  };

  const getEmptyStateTitle = () => {
    if (!allInboxNotifications?.length)
      return 'Files notifications will show here';

    return 'File Notifications';
  };

  return (
    <div className={classes.root}>
      <StandardPage
        topIcon={<NotificationIcon />}
        title={getEmptyStateTitle()}
        desc={getEmptyStateDescription()}
        // show learn more link
        // only when there are no notifications
        learnMoreLinkUrl={
          !allInboxNotifications?.length
            ? INBOX_PAGE_EMPTY_STATE_LEARN_MORE
            : ''
        }
      />
    </div>
  );
};
